import React from "react";
import { useRoutes } from "react-router-dom";
import NotFound from "pages/NotFound";
import HomeNinja from "pages/HomeNinja";
import Postspage from "pages/Postspage";
import Videos from "pages/Videos";
import EventsList from "pages/EventsList";
import Singleevent from "pages/Singleevent";
import EventsListOne from "pages/EventsListOne";
import Casepage from "pages/Casepage";

const ProjectRoutes = () => {
  let element = useRoutes([
    { path: "/", element: <HomeNinja /> },
    { path: "*", element: <NotFound /> },
    {
      path: "homeninja",
      element: <HomeNinja />,
    },
    {
      path: "postspage",
      element: <Postspage />,
    },
    {
      path: "videos",
      element: <Videos />,
    },
    {
      path: "eventslist",
      element: <EventsList />,
    },
    {
      path: "singleevent",
      element: <Singleevent />,
    },
    {
      path: "eventslistone",
      element: <EventsListOne />,
    },
    {
      path: "casepage",
      element: <Casepage />,
    },
  ]);

  return element;
};

export default ProjectRoutes;
